"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldFlipDimensions = void 0;
const shouldFlipDimensions = rotationInRadians => {
  return rotationInRadians != null && (rotationInRadians - Math.PI / 4) % Math.PI < -Math.PI / 2;
};
exports.shouldFlipDimensions = shouldFlipDimensions;